'use strict';

import React from 'react';
import {Link} from 'react-router';
import LazyLoad from 'react-lazy-load';

require('styles/AlbumsList.scss');

class AlbumsListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      albums: props.albums,
      loading: props.loading
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      albums: nextProps.albums,
      loading: nextProps.loading
    });
  }
  render() {
    return (
      <div className="albumslist-component">
        {this.state.albums.length === 0 && !this.state.loading ? <p className="text-gray text-center mt-50 fz-16">这里空空如也～～</p> : ''}
        {this.state.albums.map((album)=>{
          if(album && !album.deleted){
            return (
              <div className="albums" key={album._id}>
                <Link to={`/article/${album._id}`} className="title">{(album.name=='默认'||album.name=='')?'用户合辑推荐':album.name}</Link>
                <div className="albums-pics row">
                  <Link to={`/article/${album._id}`} className="small-9 pl-20 pr-0 columns text-center">
                    {album.medias ? album.medias.map((media)=>{
                      if(media){
                        return <div to={`/media/${media._id}`} key={media._id} className="small-4 columns pl-5 pr-5"><LazyLoad throttle={50} debounce={true} ><img className="albums-img" src={media.images.small[0]} /></LazyLoad></div>
                      }
                    }) : ''}
                  </Link>
                  <div className="albums-meta pl-0 pr-10 small-3 columns">
                    <div className="albums-count">{album.media_amount}</div>
                    {/* {album.is_top?<div className="top-tag">置顶</div>:''} */}
                    <Link to={`/article/${album._id}`} className="albums-more">详情</Link>
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
    );
  }
}

AlbumsListComponent.displayName = 'AlbumsListComponent';

// Uncomment properties you need
// AlbumsListComponent.propTypes = {};
// AlbumsListComponent.defaultProps = {};

export default AlbumsListComponent;


// WEBPACK FOOTER //
// ./src/components/AlbumsListComponent.js